import React, { useState, useEffect } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { Icon } from '@iconify/react'
import { aICreatorGetRecentAttachmentsAction } from 'src/reducers/ai-creator/action'
import { useDispatch } from 'react-redux'

const RecentFiles = props => {
  const dispatch = useDispatch()

  const { classes, selectRecentFiles } = props
  const [recentFiles, setRecentFiles] = useState()

  useEffect(() => {
    //TODO dispatch saga for getting file list
    dispatch(
      aICreatorGetRecentAttachmentsAction(response => {
        setRecentFiles(response)
      }),
    )
  }, [])

  return (
    <div className={classes.recentFilesContainer}>
      <Typography variant="title">Select Recent Files</Typography>
      <div className={classes.files}>
        {recentFiles &&
          recentFiles.map(x => {
            return (
              <div
                onClick={() => selectRecentFiles(x)}
                className={classes.file}
              >
                <Icon
                  icon="lets-icons:file-fill"
                  className={classes.fileIcon}
                ></Icon>
                <div>
                  <Typography className={classes.fileName}>
                    {x.original_file_name}
                  </Typography>
                  <Typography className={classes.fileDescription}>
                    Used in {x.number_of_courses} course
                  </Typography>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
export default withStyles(styles)(RecentFiles)
